import { render } from "./ImageUploaderFileList.vue?vue&type=template&id=5ded6fc4&scoped=true"
import script from "./ImageUploaderFileList.vue?vue&type=script&lang=js"
export * from "./ImageUploaderFileList.vue?vue&type=script&lang=js"

import "./ImageUploaderFileList.vue?vue&type=style&index=0&id=5ded6fc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ded6fc4"]])

export default __exports__